import { useEffect, useRef } from "react";

/**
 * Custom cursor — dot + lagging ring, emerald brand color.
 * Only mounts on fine-pointer (desktop) devices.
 */
const CustomCursor = () => {
  const dotRef  = useRef(null);
  const ringRef = useRef(null);
  const pos     = useRef({ x: -100, y: -100 });
  const ringPos = useRef({ x: -100, y: -100 });

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (window.matchMedia("(pointer: coarse)").matches) return;

    const dot    = dotRef.current;
    const ringEl = ringRef.current;
    if (!dot || !ringEl) return;

    let rafId;

    const onMove = (e) => {
      pos.current = { x: e.clientX, y: e.clientY };
      // Dot is instant
      dot.style.transform = `translate(${e.clientX - 3}px, ${e.clientY - 3}px)`;
    };

    const lerp = (a, b, t) => a + (b - a) * t;

    const tick = () => {
      ringPos.current.x = lerp(ringPos.current.x, pos.current.x, 0.14);
      ringPos.current.y = lerp(ringPos.current.y, pos.current.y, 0.14);
      ringEl.style.transform = `translate(${ringPos.current.x - 14}px, ${ringPos.current.y - 14}px)`;
      rafId = requestAnimationFrame(tick);
    };

    const onOver = (e) => {
      if (e.target.closest("a, button, [role='button'], input, textarea, select, label")) {
        dot.classList.add("active");
        ringEl.classList.add("active");
      }
    };

    const onOut = (e) => {
      if (e.target.closest("a, button, [role='button'], input, textarea, select, label")) {
        dot.classList.remove("active");
        ringEl.classList.remove("active");
      }
    };

    window.addEventListener("mousemove", onMove);
    document.addEventListener("mouseover", onOver);
    document.addEventListener("mouseout", onOut);
    rafId = requestAnimationFrame(tick);

    return () => {
      window.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseover", onOver);
      document.removeEventListener("mouseout", onOut);
      cancelAnimationFrame(rafId);
    };
  }, []);

  return (
    <>
      <div ref={dotRef}  className="c-dot"  aria-hidden="true" />
      <div ref={ringRef} className="c-ring" aria-hidden="true" />
    </>
  );
};

export default CustomCursor;
